module.exports = __webpack_public_path__ + "img/lange_crub.37608afb.jpg";